import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const sliderSlice = createSlice({
  name: "slider",
  initialState: {
    sliderData: [],
    isError: false,
  },

  reducers: {
    fetchSliderSuccess: (state, action) => {
      state.isError = false;
      state.sliderData = action.payload;
    },
    fetchSliderFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchSliderSuccess, fetchSliderFailure } = sliderSlice.actions;

export const fetchSlider = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchSliderSuccess(response.data.banners));
  } catch (error) {
    dispatch(fetchSliderFailure());
  }
};

export default sliderSlice.reducer;
